export const contexts = {
  home: 'home',
  register: 'register',
  login: 'login',
  signUp: 'signUp',
  bulkOrder: 'bulkOrder',
  addAddress: 'addAddress',
  notFound: 'notFound',
};

export const contextToPageNameMap = {
  home: 'Home',
  register: 'Register',
  login: 'Login',
  signUp: 'Sign Up',
  bulkOrder: 'Order',
  addAddress: 'Add Address',
  notFound: 'Not Found',
};
